import { message, Table, Space, Button, Select, Pagination, Dropdown, Input } from "antd";
import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, checkp, getAdmin, delrecord, confirmBox, exportToCSV } from '../../utils/functions'
import { EditOutlined, DownOutlined, DeleteOutlined } from '@ant-design/icons';
import CustModal from "../../components/ShowModal";
import renderFileList from "../../components/renderFileList";
import InvoiceForm from "./InvoiceForm";
import ZqdjForm from "./Ht_zqdj_editor";
import InvoiceDetails from "./InvoiceDetails";
import DateSelector from '../../components/DateSelector';

const {Option} = Select;
const admin = getAdmin();
function InvoiceList({ searchKeys, print = false }) {
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pageSizeOptions = [10, 20, 50, 100, 500];

    const [editingRecord, setEditingRecord] = useState(null);
    const [activeKey, setActiveKey] = useState('1');
    const [dates, setDates] = useState({});

    const loadingRef = useRef();
    useEffect(()=>{
        if(print){
            exportToCSV(data, columns.slice(1, -1), "销项票开票总览")
        }
    },[print])
    useEffect(() => {
        const fetchItems = () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const params = { page: currentPage, limit: pageSize, ...dates, ...filters, ack: activeKey, ...searchKeys };
                if (filters.singleMonth) {
                    const { startTs, endTs } = getMonthStartEnd(filters.singleMonth);
                    params.startTs = startTs;
                    params.endTs = endTs;
                }
                webPost('invoicelist', params).then((response) => {
                    if (response && response.data) {
                        if (response.total < 1) {
                            message.info('未找到匹配数据');
                        }
                        const newdata = response.data.map((rs)=>{
                            return {...rs, fp_type: Number(rs.fp_type) === 1 ? '电子专票' : '普票' }
                        })
                        setData(response.data);
                        setTotal(response.total);
                    }
                })
            } catch (e) {
                setData([]);
                setTotal(0);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [searchKeys, currentPage, pageSize, freshData, activeKey]);


    const columns = [
        {
            title: '序号', dataIndex: 'xd', width: 64,
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        searchKeys?.ack === 3 ? { title: '制单日期', dataIndex: 'make_date', width: 90 } : { title: '制单日期', dataIndex: 'make_date2', width: 90 },
        searchKeys?.ack === 3 && { title: '单位名称', dataIndex: 'mf_dw', width: 200, },
        { title: '项目名称', dataIndex: 'xmmc', width: 200, },
        searchKeys?.ack !== 3 && { title: '制单人', dataIndex: 'maker_name', width: 100 },
        { title: '发票类型', dataIndex: 'fp_type', width: 100 },
        { title: '开票税率%', dataIndex: 'kpsl', width: 100 },
        { title: '不含税金额', dataIndex: 'bhsje', width: 100 },
        { title: '税额', dataIndex: 'se', width: 100 },
        { title: '含税金额', dataIndex: 'amount', width: 140, },
        searchKeys?.ack === 3 && { title: '发票号码', dataIndex: 'invoice_no', width: 140, },
        searchKeys?.ack === 3 && { title: '外经证编号', dataIndex: 'wjz_no', width: 140, },
        { title: '应收税款', dataIndex: 'amount_sj', width: 140, },
        searchKeys?.ack === 3 && { title: '预缴合计', dataIndex: 'sum_se', width: 140, },
        { title: '附件:凭证', dataIndex: 'files1', width: 140, render: (t) => renderFileList(t) },
        { title: '备注', dataIndex: 'ps', width: 140 },
        { title: '备注2', dataIndex: 'ps2', width: 160, },
        searchKeys?.ack !== 3 && {
            title: '状态', dataIndex: 'status', width: 100, render: (t, rs) => {
                let res = '';
                switch (Number(t)) {
                    case -1:
                        res = '审核被拒：';
                        break;
                    case 0:
                        res = '草稿';
                        break;
                    case 1:
                        res = '审核中';
                        break;
                    case 2:
                        res = '待登记债权';
                        break;
                    case 3:
                        res = '完成债权登记';
                        break;
                }
                return res;
            }
        },
        {
            title: '操作',
            key: 'action',
            width: 260,
            fixed: 'right',
            render: (_, record) => {
                const rst = [];
                const state = Number(record.status);
                const menuItems = [];
                switch (state) {
                    case -1: case 0:
                        if (record.maker_name === admin?.['name']) {
                            rst.push(<Button key={`del_key${record.id}-1`} type="link" danger icon={<DeleteOutlined />} onClick={() =>
                                delrecord(webPost, 'del_inv', record.id, saveSuccess, null)}>删除</Button>);
                            rst.push(<Button key={`key${record.id}-1`} type="link" icon={<EditOutlined />} onClick={() => showModal(record, 'edit')}>修改</Button>);
                            menuItems.push({
                                key: 'edit',
                                label: (
                                    <Button
                                        type="link"
                                        icon={<EditOutlined />}
                                        onClick={(e) => {
                                            e.stopPropagation(); // 阻止事件冒泡
                                            showModal(record, 'edit');
                                        }}
                                    >
                                        修改
                                    </Button>
                                ),
                            });
                        }
                        break;
                    case 2:
                        if (checkp('zqdj')) {
                            rst.push(<Button type="link" key={`zqdj${record.id}-2`} danger onClick={() => showModal(record, 'zqdj')}>债权登记</Button>);
                            menuItems.push({
                                key: 'zqdj',
                                label: (
                                    <Button
                                        type="link"
                                        danger
                                        onClick={(e) => {
                                            e.stopPropagation(); // 阻止事件冒泡
                                            showModal(record, 'zqdj');
                                        }}
                                    >
                                        债权登记
                                    </Button>
                                ),
                            });
                        }
                        break;
                    case 3:
                        if (checkp('zqdjxg')) {
                            rst.push(<Button type="link" key={`zqdj${record.id}-2`} danger onClick={() => showModal(record, 'zqdj')}>修改债权登记</Button>);
                            menuItems.push({
                                key: 'zqdjxg',
                                label: (
                                    <Button
                                        type="link"
                                        danger
                                        onClick={(e) => {
                                            e.stopPropagation(); // 阻止事件冒泡
                                            showModal(record, 'zqdj');
                                        }}
                                    >
                                        修改债权登记
                                    </Button>
                                ),
                            });
                        }
                        break;
                }
                const actionMenu = menuItems.length > 0 ? (
                    <Dropdown
                        menu={{ items: menuItems }}
                        trigger={['click']}
                        placement="bottomRight"
                    >
                        <Button type="link" onClick={(e) => e.preventDefault()}>
                            <Space>
                                更多
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                ) : null;
                rst.push(<Button type="default" onClick={() => showModal(record, 'details')}>查看详情</Button>)
                if (state > 1 && checkp('all')) {
                    rst.push(<Button type="link" key={`key${record.id}-f`} danger onClick={() => showModal(record, 'del')}>废弃</Button>);
                }
                // return <Space.Compact><Button type="default" onClick={() => showModal(record, 'details')}>查看详情</Button>{actionMenu}</Space.Compact>;
                return <Space.Compact>{rst}</Space.Compact>
            },
        },
    ].filter(Boolean);

    const showModal = async (record = null, action) => {
        if (action === 'del') {
            confirmBox(async () => {
                const res = await webPost("delItem", { tb: 'invoice', id: record.id });
                if (res) {
                    message.success("删除成功!");
                    saveSuccess();
                } else {
                    message.error("删除失败!");
                }

            })
            return;
        }
        setEditingRecord(record);
        setModalVisible(action);
    };

    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
    }
    const saveSuccess = () => {
        setfreshData(Math.random()); //强制刷新数据
        handleModalClose();
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    return (
        <FullHeightLayout
            headerContent={
                !(searchKeys && searchKeys.sn) && <Space size="middle">
                    <DateSelector onChange={(v) => { setDates(v); }} />
                    <Select placeholder='类型' style={{ width: '120px' }} onChange={(v) => setFilters(prev => ({ ...prev, "lx": v }))}>
                        <Option value='1'>项目名称</Option>
                        <Option value='2'>项目编号</Option>
                        <Option value='3'>制单人</Option>
                        <Option value='4'>开票税率</Option>
                        <Option value='5'>金额</Option>
                    </Select>
                    <Input onChange={(e) => setFilters(prev => ({ ...prev, 'key': e.target.value }))} />
                    <Button type="primary" onClick={saveSuccess} >搜索</Button>
                    {/* <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal(null, 'edit')}>新建支付申请</Button> */}
                </Space>
            }
            bodyContent={
                <>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey='id'
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 1440,
                            y: 'calc(100vh - 300px)',
                        }}
                        tableLayout="fixed"
                        onRow={(record, index) => ({
                            onDoubleClick: (event) => {
                                navigate('/htcx/' + record.sn);
                            },
                        })}
                    />

                    <CustModal title='详情' open={modalVisible === 'zqdj'} onCancel={handleModalClose} footer={false}>
                        <ZqdjForm invoice={editingRecord} />
                    </CustModal>
                    <CustModal title='详情' open={modalVisible === 'details'} onCancel={handleModalClose} footer={false}>
                        <InvoiceDetails detailData={editingRecord} webPost={webPost} />
                    </CustModal>
                    <CustModal
                        title={'修改发票申请'}
                        open={modalVisible === 'edit'}
                        onCancel={handleModalClose}
                        footer={false}
                    >
                        <InvoiceForm myItem={editingRecord} onSave={saveSuccess} fkey={Math.random()} />
                    </CustModal>
                </>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        />
    )
}


export default InvoiceList;
